import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumber } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import { validateOptionalTable } from "../../../../utils/validateTable";
import DynamicStaticTable from "../../../../Components/Common/DynamicStaticTable";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI401_2 = ({ hide }) => {
  const inputData = [
    {
      fieldName: "benifitProvided",
      title:
        "a. What percentage of the procurement budget allocated for significant locations of operation is utilized for suppliers local to those specific operations, considering both products and services purchased locally?",
      type: "array",
      fields: [
        {
          fieldName: "benefit",
          title: "Benefits",
          type: "text",
          placeholder: "Enter Text",
          width: "30%",
        },
        {
          fieldName: "noOfEmployeesBenifited",
          title: "No. of Employees Benefited",
          type: "number",
          width: "29%",
          placeholder: "Enter Number",
        },
        {
          fieldName: "amount",
          title: "Amount",
          type: "number",
          width: "28%",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const questionData = [
    {
      fieldName: "significantLocationsOfOperation",
      title:
        "b. Define what is meant by ‘significant locations of operation’ :",
      type: "text",
      placeholder: "Enter Text",
    },
  ];

  const defaultSegments = [
    "Life Insurance",
    "Healthcare",
    "Disability and Invalidity Coverage",
    "Parental Leave",
    "Retirement Provision",
    "Stock Ownership",
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [disabled, setDisabled] = useState(false);
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI400`);
      const res1 = res?.data?.data?.GRI400?.benifitsData;
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      significantLocationsOfOperation:
        data?.significantLocationsOfOperation || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "distance" && !validateNumber(value)) return;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = "Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // let v1 = validateForm();
      let v2 = validateOptionalTable(
        inputData,
        tables,
        setTabErros,
        "",
        "benefit",
        defaultSegments
      );

      if (!v2) return;

      let transformedData2 = {
        benifitsData: { ...restructureData(tables), ...formData },
        type: "GRI400",
        submitted401_2: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri400/401-3/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/401-3/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && <p className={styles.section_heading}>401 : Material Used</p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1.5rem" : "2rem" }}>
        401-2 : Benefits provided to full-time employees that are not provided
        to temporary or parttime employees
      </p>
      {/* a */}
      <DynamicStaticTable
        {...{
          inputData,
          tables,
          setTables,
          errors: tabErrors,
          setErrors: setTabErros,
          disabled: disabled,
          data: data,
          defaultSegments,
          parameter: "benefit",
          hide: hide
        }}
      />
      {questionData.map((el) => (
        <Box sx={{ mt: hide ? 1 : 2 }}>
          <p className={styles.ques_heading}>{el.title}</p>
          <Box sx={{ ml: 2.5 }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI401_2;
